import {
  BattlePlayerInfo,
  BattleSideReveal,
  DigitalPassport,
} from "../types/battle"

export function passportToPlayerExtras(
  passport: DigitalPassport | null | undefined
): Pick<
  BattlePlayerInfo,
  "affiliationElement" | "avatarVariant" | "profileFrameKey" | "guardianPath"
> | null {
  if (!passport) return null
  return {
    affiliationElement: passport.affiliationElement ?? null,
    avatarVariant: passport.avatarVariant ?? 1,
    profileFrameKey: passport.profileFrameKey ?? null,
    guardianPath: passport.guardianPath ?? null,
  }
}

export function enrichBattlePlayer(
  player: BattlePlayerInfo,
  fallback?: Partial<
    Pick<
      BattlePlayerInfo,
      "affiliationElement" | "avatarVariant" | "profileFrameKey" | "guardianPath"
    >
  > | null
): BattlePlayerInfo {
  if (!fallback) return player
  return {
    ...player,
    affiliationElement:
      player.affiliationElement ?? fallback.affiliationElement ?? null,
    avatarVariant: player.avatarVariant ?? fallback.avatarVariant ?? 1,
    profileFrameKey: player.profileFrameKey ?? fallback.profileFrameKey ?? null,
    guardianPath: player.guardianPath ?? fallback.guardianPath ?? null,
  }
}

export function enrichBattleSidePlayer(
  side: BattleSideReveal,
  fallback?: Partial<
    Pick<
      BattlePlayerInfo,
      "affiliationElement" | "avatarVariant" | "profileFrameKey" | "guardianPath"
    >
  > | null
): BattleSideReveal {
  return {
    ...side,
    player: enrichBattlePlayer(side.player, fallback),
  }
}
